import APIClient from './index';
import _ from 'lodash';

export const getShopProducts = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Shop/products', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const fetchHomeBlendedFeed = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/Shop/home/blended', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
